var React = require('react');

function ChevronUp (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ChevronUp"},React.createElement("path",{"id":"Vector 22 (Stroke)","fillRule":"evenodd","clipRule":"evenodd","d":"M15.306 12.1824C15.6952 11.7714 15.6952 11.1277 15.306 10.7167L7.99987 3L0.693761 10.7167C0.304554 11.1277 0.304554 11.7714 0.693761 12.1824C1.11425 12.6266 1.82141 12.6266 2.2419 12.1824L7.99987 6.1009L13.7578 12.1824C14.1783 12.6266 14.8855 12.6266 15.306 12.1824Z","fill":"#E8EFFF"})));
}

ChevronUp.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ChevronUp;

ChevronUp.default = ChevronUp;
